import { currentLocale, getUrl } from "../../../../../helpers";

const constructFetchUrl = (queryString, offset) => {
    const baseUrl = getUrl();
    const paginationSegment = `/${currentLocale.get()}/api/partnersearch/pagination`;

    const start = queryString ? '&' : '?';
    const fetchUrl = `${baseUrl}${paginationSegment}${queryString}${start}start=${offset}`;

    return fetchUrl;
}

export default constructFetchUrl;